import React, { Component } from 'react';
import ctx from '@/assets/js/ctx';
import { checkToken } from '@/assets/js/hoc.js';
import Title from '@/components/Title';
import NavTxt from '@/components/NavTxt';
import { PullToRefresh, Grid, ListView, WingBlank, WhiteSpace, Carousel } from 'antd-mobile';
import { getUrlToken } from '@/assets/js/string';
import { toCart, axiosParam, toPage, toSearch, string, toBookCover } from '@/assets/js/string';
import DocumentTitle from 'react-document-title';
import { loadingMore } from '@/assets/js/content';
import BookListItem from '@/components/BookListItem';
import CountDown from '@/components/CountDown';
import { List } from 'antd-mobile/lib/index';
import BannerGroup from '@/components/BannerGroup';
import { getTheme, getSetting } from '@/assets/js/setting';
import moment from 'moment';
import $ from 'jquery';
import sdk from '@/routes/wxShare'
import NavigatorTabbar  from '@/components/NavigatorTabbar'

import './index.module.css'

const Item = List.Item;
const Brief = Item.Brief;

function MyBody(props) {
  return (
    <div className={`aui-margin-b-0 aui-margin-t-0 aui-bg-white free-list aui-border-radius-10`}>
      <ul className={``}>{props.children}</ul>
    </div>
  );
}

function LikeBody(props) {
  return <div className={`book-list aui-margin-10 aui-margin-t-0 aui-margin-b-0`}>{props.children}</div>;
}

@checkToken
export class index extends Component {
  static contextType = ctx;

  constructor() {
    super();
    this.state = {
      stamp: '',
      dataSource: new ListView.DataSource({
        // ListView组件的数据源
        rowHasChanged: (row1, row2) => row1 !== row2,
      }),
      keyword: '',
      dataList: [],
      isLoading: true,
      userLikeList: [],
      bookSortList: [],
      flashList: [],
      bookRecommendList: [],
      editorRecommendList: [],
      userOrderList: [],
      userHistoryList: [],
      freeList: [],
      newList: [],
      subList: [],
      hotList: [],
      douyin: '',
      refreshing: true,
      down: true,
      hasMore: true,
      isFirstLoaded: true,
      pagesize: 40,
      page: 0,
      useBodyScroll: true,
      sortSegmentIndex: 0,
      sorting: 6,
      status: 0,
      day1: '',
      totalCount: 10,
      dataSource: new ListView.DataSource({
        rowHasChanged: (row1, row2) => row1 !== row2,
      }),
      firstHomeListHeight : 0
    };
  }

  reqUserHistoryList = action => {
    const { page, pagesize, stamp } = this.state;
    let params = {};
    params = $.extend(params, axiosParam(this.context, stamp));
    this.context.axios
      .post(global.constants.apiUrl + `user/reqUserHistoryList`, params)
      .then(res => {
        if (res.code == 1) {
          this.setState({
            userHistoryList: res.data,
          });
        }
      });
  };

  reqUserOrderList = action => {
    const { page, pagesize, stamp } = this.state;
    let params = {
      page: page + 1,
      pagesize: pagesize,
    };
    params = $.extend(params, axiosParam(this.context, stamp));

    this.context.axios.post(global.constants.apiUrl + `user/getUserOrderList`, params).then(res => {
      if (res.code == 1) {
        this.setState({
          userOrderList: res.data,
        });
      }
    });
  };

  reqUserLikeBookList = action => {
    const { page, pagesize, stamp } = this.state;
    let params = {
      typeid: 'home',
      page: page + 1,
      pagesize: pagesize,
      price: 1
    };
    params = $.extend(params, axiosParam(this.context, stamp));

    this.context.axios.post(global.constants.apiUrl + `user/getUserLike`, params).then(res => {
      if (res.code == 1) {
        if (res.data.length > 0) {
          this.state.userLikeList = [...this.state.userLikeList, ...res.data];
          this.setState({
            page: page + 1,
            userLikeList: this.state.userLikeList,
            dataSource: this.state.dataSource.cloneWithRows(this.state.userLikeList),
          });

          this.setState({
            isFirstLoad: false,
          });
        } else {
          this.setState({
            hasMore: false,
            isLoading: false,
            isFirstLoad: false,
          });
        }
        this.setState({
          refreshing: false,
        });
      }
    });
  };

  reqBookRecommendList = action => {
    const { stamp, sorting } = this.state;
    let params = {};
    params = $.extend(params, axiosParam(this.context, stamp));

    this.context.axios
      .post(
        global.constants.apiUrl + `recommend/getList`,
        (params = $.extend(params, axiosParam(this.context, stamp)))
      )
      .then(res => {
        if (res.code == 1) {
          switch (action) {
            case 1:
              this.setState({
                subList: res.data.sub,
              });
              break;
            case 2:
              this.setState({
                bookRecommendList: res.data.new,
              });
              break;
            case 3:
              this.setState({
                newList: res.data.discount,
              });
              break;
            case 4:
              this.setState({
                hotList: res.data.hot,
              });
              break;
            default:
              this.setState({
                subList: res.data.sub,
                bookRecommendList: res.data.new,
                newList: res.data.discount,
                hotList: res.data.hot,
                totalCount: res.data.total,
                douyin: res.data.douyin,
                isLoading: false,
              });
          }
        }
      });
  };

  onRefresh = () => {
    this.setState({
      page: 0,
      refreshing: true,
      dataSource: new ListView.DataSource({
        rowHasChanged: (row1, row2) => row1 !== row2,
      }),
      userLikeList: [],
    });
    this.reqUserOrderList();
    this.reqBookRecommendList();
    this.reqUserLikeBookList();
  };

  getGridStyle = index => {
    if (index % 4 == 0) {
      return { paddingLeft: '0.75rem' };
    } else if ((index + 3) % 4 == 0) {
      return { paddingLeft: '0.6rem', paddingRight: '0.3rem' };
    } else if ((index + 2) % 4 == 0) {
      return { paddingLeft: '0.3rem', paddingRight: '0.6rem' };
    } else if ((index + 1) % 4 == 0) {
      return { paddingRight: '0.75rem' };
    }
  };

  toLink = (url, e) => {
    switch (url) {
      case 'topList/last':
        if (e.ver === 'v1') location.href = 'http://i.mixs.cn/upload/fm_mixs_cn/tzys/index.html';
        else location.href = 'http://i.mixs.cn/upload/fm_mixs_cn/tzys/fx.html';
        break;
      default:
        toPage(url, e);
        break;
    }
  };


    /* 搜索 */
  search = () => {
    if (this.state.keyword == '') {
      Toast.info('请输入关键词', 1)
      return
    }
    toSearch(this.state.keyword,this.context)
  }


  //搜索框onChange事件
  onChange = (e) => {
    this.setState({
      keyword: e.target.value
    })
  };

  changeHomeListFirstHeight = (e) => {
    this.setState({
      firstHomeListHeight: e
    })
  };

  render() {
    const {
      hasMore,
      userOrderList,
      dataSource,
      refreshing,
      isLoading,
      pagesize,
      bookSortList,
      flashList,
      bookRecommendList,
      userHistoryList,
      subList,
      firstHomeListHeight,
      editorRecommendList,
      newList,
      setting,
      totalCount,
      douyin
    } = this.state;
    const {
      onRefresh,
      reqUserLikeBookList,
      changeHomeListFirstHeight,
      onEndReached,
      toLink,
      reqBookRecommendList,
      search
    } = this;
    const antIcon = <div className={`am-icon-dot`} />;
    var day3 = new Date();
    day3.setTime(day3.getTime());
    var s3 = day3.getMonth() + 1 + '月' + day3.getDate() + '日';

    const drbTitle = <div className={`aui-font-size-18 aui-text-color-black`}>新人必选</div>;

    const moduleList = Array.from([
      {
        icon: require('@/assets/icon/书库.png'),
        name: '书库',
        link: 'topList/sk',
      },
      {
        icon: require('@/assets/icon/秒杀.png'),
        name: '秒杀',
        link: 'topList/mshd',
      },
      {
        icon: require('@/assets/icon/上新.png'),
        name: '上新',
        link: 'topList/qnb',
      },
      {
        icon: require('@/assets/icon/999独家.png'),
        name: 'VIP专辑',
        link: 'topList/ffzj',
      },
      {
        icon: require('@/assets/icon/tjb.png'),
        name: '必录榜',
        link: 'topList/tjb',
      },
      {
        icon: require('@/assets/icon/xnk.png'),
        name: '小年卡',
        link: 'topList/xnk',
      },
      {
        icon: require('@/assets/icon/jcb.png'),
        name: '大年卡',
        link: 'topList/jcb',
      },
      {
        icon: require('@/assets/icon/dpk.png'),
        name: '短篇卡',
        link: 'topList/dpk',
      },
      {
        icon: require('@/assets/icon/lyk.png'),
        name: '灵异卡',
        link: 'topList/lyk',
      },
      {
        icon: require('@/assets/icon/gvzx.png'),
        name: '高V专享',
        link: 'topList/gvzx',
      },
      {
        icon: require('@/assets/icon/mfzj.png'),
        name: '精品',
        link: 'topList/good',
      },
      {
        icon: require('@/assets/icon/cp.png'),
        name: 'A+书库',
        link: 'topList/tzsk',
      },
      {
        icon: require('@/assets/icon/ly.png'),
        name: '恐怖',
        link: 'topList/ly',
      },
      {
        icon: require('@/assets/icon/female.png'),
        name: '女生',
        link: 'topList/female',
      },
      {
        icon: require('@/assets/icon/male.png'),
        name: '男生',
        link: 'topList/male',
      },
      {
        icon: require('@/assets/icon/hd.png'),
        name: '短篇单售',
        link: 'topList/dpds',
      },
      {
        icon: require('@/assets/icon/warrant.png'),
        name: '独家',
        link: 'topList/warrant',
      },
      {
        icon: require('@/assets/icon/999dj.png'),
        name: '非独家',
        link: 'topList/mfzj',
      }
    ]);

    return (
      <>
        <DocumentTitle
          title={this.context.siteinfo ? this.context.siteinfo.title + ' | 版权商城' : ''}
        ></DocumentTitle>

        <div className={`home aui-bg-wx`}>
          <div className={`aui-content aui-bg-wx ${getTheme()}`}>
            {isLoading ? (
              <div style={{ marginTop: '0px' }}>{antIcon}</div>
            ) : (
              <div className={`classify aui-bg-wx ${getTheme()}`}>
                <ListView
                  ref={el => (this.lv = el)}
                  dataSource={dataSource}
                  pageSize={pagesize}
                  useBodyScroll={false}
                  style={{ marginTop: '0px', height: document.documentElement.clientHeight -75,overflow:'hidden',overflowY:'scroll'}}
                  renderHeader={(sectionData, sectionID) => (
                    <>
                      <div
                        className={`aui-margin-10`}
                        style={{ width: 'auto', overflow: 'hidden',borderRadius:'15px'}}
                      >
                        {<BannerGroup positionId="8" con={this.contenxt} />}
                      </div>
                      <WhiteSpace />
                       <div class={`aui-searchbar`} id="search">
                    <div class="aui-searchbar-input" tapmode>
                      <i class="aui-iconfont aui-icon-search"></i>
                      <input type="search" value={this.state.keyword} placeholder="书名/作者/书号"
                            onChange={this.onChange.bind(this)}
                            defaultValue={this.state.keyword}/>
                    </div>
                    <div class="aui-btn aui-btn-danger cur" onClick={() => {
                      search()
                    }}>搜索
                    </div>
                  </div>

                      <WhiteSpace />
                      <div className={`content aui-margin-10 `}>
                        <div className={`aui-bg-white module aui-border-radius-10`}>
                          <Grid
                            data={moduleList}
                            columnNum={6}
                            hasLine={false}
                            square={true}
                            onClick={el => toLink(el.link, this.context)}
                            style={{ height: 'auto' }}
                            renderItem={(dataItem,index) => (
                              <div className={`aui-text-align-c`}>
                                <img
                                  src={dataItem.icon}
                                  className={`aui-margin-center aui-margin-t-10`}
                                  style={{ width: '45px', height: '45px' }}
                                  alt=""
                                />
                                <div className={`aui-margin-t-10`}
                                >
                                  <span className={`aui-text-color-black aui-text-bold ${index > 4 ? 'aui-font-size-14' : 'aui-font-size-14'} `}>
                                    {dataItem.name}
                                  </span>
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  renderBodyComponent={() => <MyBody />}
                  renderSectionBodyWrapper={sectionID => <LikeBody />}
                    renderRow={(rowData, sectionId, rowID) => {
                      if (this.context.ver === 'v1' && rowID === '0') {
                        return <>
                          <div className={`aui-col-xs-6`} style={{'height':firstHomeListHeight}}>
                            <div className={`aui-bg-white aui-border-radius-10 aui-padded-10 aui-margin-t-10`} style={rowID % 2 == 0 ? { 'marginRight': '5px','height': '100%' } : { 'marginLeft': '5px','height': '100%' }}>
                              <BannerGroup positionId="6" con={this.contenxt} />
                            </div>
                          </div>
                        </>
                      }
                      else {
                        return <BookListItem {...this.props} homeList={rowData} rowID={rowID} changeHomeListFirstHeight={changeHomeListFirstHeight}/>;
                      }
                  }}
                  renderFooter={() => (
                    <div style={{ clear: 'both', padding: 0, textAlign: 'center' }}>
                      {isLoading ? antIcon : hasMore ? '' : '没有更多'}
                    </div>
                  )}
                  pullToRefresh={
                    <PullToRefresh
                      indicator={{
                        activate: antIcon,
                        deactivate: antIcon,
                        release: antIcon,
                        finish: antIcon,
                      }}
                      refreshing={refreshing}
                      distanceToRefresh={55}
                      onRefresh={onRefresh}
                    />
                  }
                  onEndReached={reqUserLikeBookList}
                  onEndReachedThreshold={20}
                />
              </div>
            )}
          </div>
        </div>
          <NavigatorTabbar selectedTab="home"></NavigatorTabbar>
      </>
    );
  }

  componentDidMount() {
    var timestamp = new Date().getTime();

    var day1 = new Date();
    day1.setTime(day1.getTime() + 24 * 60 * 60 * 1000);
    var s1 = day1.getFullYear() + '/' + (day1.getMonth() + 1) + '/' + day1.getDate();

    this.setState(
      {
        stamp: timestamp,
        day1: s1,
      },
      () => {
        this.reqUserHistoryList();
        this.reqUserOrderList();
        this.reqBookRecommendList();
        this.reqUserLikeBookList();
        
        sdk.getJSSDK({ title: this.context.siteinfo ? this.context.siteinfo.title + ' | 版权商城' : '',url: window.location.href, type: 'common'},timestamp,this.context)
      }
    );
  }
}

export default index;
